import { computed, ref } from 'vue';
import i18n, { SUPPORTED_LANGS } from './index';
import type { TerminalLocale } from '@/types/interfaces/navigator';

const terminalLocale = ref<TerminalLocale | null>(null);

/**
 * Временный рубильник: сужение списка языков по настройке терминала
 * отключено, во всех контекстах показываем полный страновой каталог.
 * Данные терминала при этом продолжают прилетать в terminalLocale —
 * для возврата сужения достаточно переключить флаг
 */
const IS_TERMINAL_NARROWING_ENABLED = false;

/**
 * Языки, доступные в текущем контексте: набор терминала (если карточка его
 * отдала), пересечённый со страновым каталогом, иначе — страновой каталог
 * целиком (вне заведения пользователю доступны все языки страны)
 */
export const availableLanguages = computed(() => {
	const supported = terminalLocale.value?.supported;

	if (!IS_TERMINAL_NARROWING_ENABLED || !supported?.length) {
		return SUPPORTED_LANGS;
	}

	const languages = SUPPORTED_LANGS.filter(lang =>
		supported.includes(lang.code)
	);

	return languages.length ? languages : SUPPORTED_LANGS;
});

/**
 * Применяет locale-блок терминала и сводит активную локаль к разрешённому
 * набору. Клампится только локаль сессии: localStorage и язык профиля не
 * трогаем, чтобы не терять выбор пользователя для других заведений
 */
export const setTerminalLocale = (locale: TerminalLocale | null) => {
	terminalLocale.value = locale;

	if (!locale) {
		return;
	}

	const allowed: string[] = availableLanguages.value.map(lang => lang.code);

	if (allowed.includes(i18n.global.locale.value)) {
		return;
	}

	i18n.global.locale.value = allowed.includes(locale.default)
		? locale.default
		: allowed[0];
};

export const clearTerminalLocale = () => {
	terminalLocale.value = null;
};
